import permissions from '../Apollo/permissions';
import { useControlProxy } from './useControlProxy';
import { METHOD, PATH, PIPELINE_SCOPE } from './control-api';
import useTrackWithUser from '../hooks/useTrackWithUser';

export function useDeployPipeline(options = {}) {
  const [trackWithUser] = useTrackWithUser('pipeline_deployed');
  const [executeMutation, response] = useControlProxy({
    permission: permissions.deployPipeline,
    ...options,
  });

  const deployPipeline = ({ clusterId, writekey, pipelineJSON }) => {
    return executeMutation({
      path: PATH.Pipeline,
      method: METHOD.POST,
      body: { pipeline: pipelineJSON, scope: PIPELINE_SCOPE },
      clusterId,
      writekey,
    }).then(response => {
      if (!response.errors) {
        trackWithUser({ clusterId, pipelineWritekey: writekey });
      }
      return response;
    });
  };
  return [deployPipeline, response];
}
